module.exports = __webpack_public_path__ + "img/pic_kh_select@2x.79844c5c.png";